import { render, staticRenderFns } from "./gp-skin.vue?vue&type=template&id=8d7768b2&scoped=true&"
import script from "./gp-skin.vue?vue&type=script&lang=js&"
export * from "./gp-skin.vue?vue&type=script&lang=js&"
import style0 from "./gp-skin.vue?vue&type=style&index=0&id=8d7768b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d7768b2",
  null
  
)

component.options.__file = "gp-skin.vue"
export default component.exports